import { useCallback, useState } from "react";
import { Form, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import Modal from "../../../../components/generic/Modal";
import { useDispatch } from "react-redux";
import { uploadFile } from "../../../../utils/uploadFile";
import { addTaskAttachment } from "../../../../store/tasks/thunks";
const { Dragger } = Upload;

const CreateAttachmentModal = ({ onCancel, selectedTask }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleFinish = useCallback(
    async (values) => {
      try {
        setSubmitting(true);

        const file = values?.file?.[0]?.originFileObj;

        const storage_url = await uploadFile({
          file,
          fields: {
            tenant_id: selectedTask?.tenant_id,
          },
        });

        await dispatch(
          addTaskAttachment({
            column_id: selectedTask?.column_id,
            tenant_id: selectedTask?.tenant_id,
            task_id: selectedTask?.id,
            filename: file.name,
            file_size_bytes: file.size,
            mime_type: file.type,
            storage_url,
          }),
        ).unwrap();

        onCancel();
      } catch (error) {
        console.error(error);
      } finally {
        setSubmitting(false);
      }
    },
    [form, selectedTask],
  );

  return (
    <Modal
      title="Add Attachment"
      open
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText="Upload"
      isProcessing={submitting}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        disabled={submitting}
      >
        <Form.Item
          label="Select File"
          name="file"
          rules={[{ required: true, message: "Please select a file." }]}
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <Dragger
            beforeUpload={() => false}
            maxCount={1}
            multiple={false}
            accept="image/*,audio/*,video/*,.pdf,.doc,.docx,.txt,.zip,.csv,.html,.xls"
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag a file to this area to upload
            </p>
            <p className="ant-upload-hint">Support for a single file upload.</p>
          </Dragger>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAttachmentModal;
